import { render, staticRenderFns } from "./WarehouseMap.vue?vue&type=template&id=23510f3f"
import script from "./WarehouseMap.vue?vue&type=script&lang=js"
export * from "./WarehouseMap.vue?vue&type=script&lang=js"
import style0 from "./WarehouseMap.vue?vue&type=style&index=0&id=23510f3f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports